import React, { createContext, useContext, useState, useCallback } from "react";

const dict = {
  it: {
    nav: { solution: "Soluzione", how: "Come funziona", vantaggi: "Vantaggi", aziende: "Aziende", partner: "Partner", book: "Contattaci", risorse: "Risorse" },
    hero: {
      overline: "Programmi di mobilità aziendale · Voli business dedicati",
      l1: "La mobilità business.",
      l2: "Ripensata.",
      sub: "Accordi quadro. Rotte programmate. Posti garantiti. Tempo recuperato.",
      intro: "JetSeat crea e gestisce programmi di mobilità aziendale su misura, con voli business dedicati sulle rotte che contano davvero per la tua azienda.",
      cta: "Richiedi il tuo programma", cta2: "Come funziona",
      pillars: ["Rotte programmate", "Posti garantiti", "Operatori certificati"],
    },
    marquee: "Accordi quadro · Rotte programmate · Posti garantiti · Tempo recuperato · ",
    problem: {
      overline: "Il problema",
      title: "Ogni settimana le stesse tratte. Ogni volta ore perse.",
      items: [
        "Traffico e trasferimenti",
        "Code, check-in e controlli",
        "Ritardi e coincidenze saltate",
        "Stress e inefficienza",
      ],
      note: "Il costo nascosto è sempre lo stesso: il tempo delle tue persone.",
    },
    solution: {
      overline: "La nostra soluzione",
      title: "Da trasferte ricorrenti a mobilità prevedibile.",
      sub: "Trasformiamo le trasferte ricorrenti in un sistema di mobilità efficiente e prevedibile.",
      cards: [
        { t: "Accordi quadro", d: "Definiamo insieme le rotte, le frequenze e i livelli di servizio." },
        { t: "Voli programmati", d: "Organizziamo voli business dedicati con operatori certificati." },
        { t: "Posti garantiti", d: "Capacità prepagata e riservata per la tua azienda." },
        { t: "Utilizzo semplice", d: "I tuoi dipendenti utilizzano i posti già garantiti, senza prenotare ogni volta." },
      ],
      tagline: "Non un charter ogni volta. Un'infrastruttura di mobilità aziendale.",
    },
    how: {
      overline: "Come funziona",
      title: "Un programma su misura, dalla A alla Z.",
      steps: [
        { t: "Analizziamo", d: "Studiamo le tue esigenze di mobilità e le tratte ricorrenti." },
        { t: "Accordo quadro", d: "Costruiamo insieme un programma su misura per la tua azienda." },
        { t: "Voli programmati", d: "JetSeat organizza i voli con operatori certificati secondo il calendario definito." },
        { t: "Posti garantiti", d: "I tuoi dipendenti trovano i posti già riservati, pronti a partire." },
      ],
      note: "Capacità garantita. Massima flessibilità. Nessuna incertezza.",
    },
    outcomes: {
      overline: "Cosa ottiene la tua azienda",
      title: "Più valore, meno frizione.",
      items: [
        { t: "Tempo recuperato", d: "Riduciamo drasticamente i tempi di viaggio." },
        { t: "Esperienza uniforme", d: "Standard elevati garantiti per tutti i viaggiatori." },
        { t: "Maggiore produttività", d: "Più incontri, più decisioni, più risultati." },
        { t: "Un unico partner", d: "Gestiamo tutto noi, dalla A alla Z." },
        { t: "Programmazione stabile", d: "Rotte e orari certi, ogni settimana." },
        { t: "Controllo e trasparenza", d: "Report, analisi e fatturazione centralizzata." },
      ],
    },
    employee: {
      overline: "I vantaggi per i tuoi dipendenti",
      title: "Meno stress. Più energia.",
      items: [
        "Arrivo pochi minuti prima della partenza",
        "Procedure rapide e dedicate",
        "Meno stress e più energia per il lavoro",
        "Più riunioni nella stessa giornata",
        "Rientro a casa la sera",
      ],
    },
    why: {
      overline: "Perché JetSeat",
      title: "Sicurezza, efficienza, network.",
      pillars: [
        { t: "Sicurezza prima di tutto", d: "Lavoriamo solo con operatori certificati e procedure rigorose." },
        { t: "Focus business", d: "Nessun lusso superfluo: solo efficienza e valore concreto per il tuo business." },
        { t: "Infrastruttura di rete", d: "Più aziende entrano nel network, più rotte, frequenze e valore crescono per tutti." },
      ],
    },
    lead: {
      overline: "Contatto",
      title: "Parliamo del tuo programma.",
      sub: "Raccontaci le tue esigenze: ti ricontattiamo per costruire il programma di mobilità su misura per la tua azienda.",
      companyName: "Nome azienda", reference: "Riferimento azienda",
      mobile: "Cellulare", phone: "Telefono", email: "Email", reason: "Motivo contatto",
      reasonPlaceholder: "Descrivi brevemente il motivo del contatto…",
      submit: "Invia richiesta", sending: "Invio…",
      success: "Richiesta ricevuta. Ti ricontatteremo a breve.",
      error: "Qualcosa è andato storto. Riprova.",
      validation: "Compila i campi obbligatori",
    },
    corporate: {
      overline: "Per le aziende",
      title: "Il tuo programma di mobilità su misura.",
      body: "Definiamo insieme rotte, frequenze e livelli di servizio. La capacità è prepagata e riservata per la tua azienda: i tuoi dipendenti utilizzano i posti già garantiti, senza prenotare ogni volta.",
      benefits: [
        { t: "Posti garantiti", d: "Capacità prepagata e riservata, sempre disponibile per il tuo team." },
        { t: "Programmazione stabile", d: "Rotte e orari certi, definiti sul tuo calendario aziendale." },
        { t: "Gestione dedicata", d: "Un unico partner, report e fatturazione centralizzata." },
      ],
      businessName: "Ragione sociale", sector: "Settore", seats: "Posti stimati nel programma",
      destinations: "Destinazioni di interesse",
      destinationsPlaceholder: "Es. Milano, Roma, Londra, Costa Azzurra…",
      destinationsNote: "Le rotte non sono pre-impostate: le definiamo insieme in fase di accordo, in base alle esigenze della tua azienda.",
      contactName: "Nome referente", contactRole: "Ruolo referente",
      email: "Email aziendale", phone: "Telefono",
      submit: "Richiedi il programma", sending: "Invio…",
      success: "Richiesta ricevuta. Ti ricontatteremo entro 48 ore.",
      error: "Qualcosa è andato storto. Riprova.",
    },
    partner: {
      overline: "Partnership",
      title: "Operatori AOC & advisor.",
      body: "JetSeat è asset-light: costruiamo la rete di operatori certificati AOC e advisor che rendono possibili i programmi di mobilità. Se gestisci una flotta o rappresenti clienti business ricorrenti, parliamone.",
      orgType: "Tipo di organizzazione", orgOpts: ["Operatore AOC", "Advisor", "Altro"],
      company: "Azienda", name: "Referente", email: "Email", phone: "Telefono", message: "Messaggio",
      submit: "Contattaci", success: "Grazie. Ti ricontatteremo.",
    },
    faq: {
      overline: "Domande frequenti", title: "FAQ.",
      items: [
        { q: "Come si organizzano i voli aziendali per le trasferte ricorrenti?", a: "Con JetSeat definisci un programma di mobilità su misura: analizziamo le tratte ricorrenti della tua azienda, stabiliamo rotte, frequenze e livelli di servizio, e organizziamo voli business dedicati con operatori certificati. I dipendenti trovano i posti già riservati, senza prenotare ogni volta." },
        { q: "Cosa sono gli accordi quadro per la mobilità business?", a: "Un accordo quadro è un'intesa con cui l'azienda concorda in anticipo rotte, frequenze, livelli di servizio e capacità di posti a un prezzo definito. Garantisce continuità operativa, budget prevedibile e priorità sulle rotte business più utilizzate." },
        { q: "È possibile prenotare voli privati per aziende in Italia?", a: "Sì. JetSeat opera voli privati business dedicati per aziende sulle principali rotte italiane ed europee, tramite operatori certificati AOC. Le rotte non sono pre-impostate: le definiamo insieme in base alle esigenze della tua azienda." },
        { q: "Quanto costa un programma di mobilità aziendale con jet privato?", a: "Il costo dipende da rotte, frequenze e numero di posti del programma. La capacità è prepagata e riservata: definiamo insieme un prezzo concordato per posto, con budget prevedibile e fatturazione centralizzata." },
        { q: "I posti sono garantiti e chi opera i voli?", a: "Sì, i posti sono prepagati e garantiti per la tua azienda. I voli sono operati esclusivamente da operatori certificati con procedure rigorose: la sicurezza viene prima di tutto." },
      ],
    },
    footer: { tagline: "Proteggere il tempo delle persone e trasformarlo in valore per le aziende.", missionLabel: "La nostra missione", rights: "Tutti i diritti riservati.", admin: "Area riservata" },
  },
  en: {
    nav: { solution: "Solution", how: "How it works", vantaggi: "Benefits", aziende: "Companies", partner: "Partners", book: "Contact", risorse: "Resources" },
    hero: {
      overline: "Corporate mobility programs · Dedicated business flights",
      l1: "Business mobility.",
      l2: "Rethought.",
      sub: "Framework agreements. Scheduled routes. Guaranteed seats. Time recovered.",
      intro: "JetSeat designs and runs tailored corporate mobility programs, with dedicated business flights on the routes that truly matter to your company.",
      cta: "Request your program", cta2: "How it works",
      pillars: ["Scheduled routes", "Guaranteed seats", "Certified operators"],
    },
    marquee: "Framework agreements · Scheduled routes · Guaranteed seats · Time recovered · ",
    problem: {
      overline: "The problem",
      title: "The same routes every week. Hours lost every time.",
      items: [
        "Traffic and transfers",
        "Queues, check-in and security",
        "Delays and missed connections",
        "Stress and inefficiency",
      ],
      note: "The hidden cost is always the same: your people's time.",
    },
    solution: {
      overline: "Our solution",
      title: "From recurring trips to predictable mobility.",
      sub: "We turn recurring business trips into an efficient, predictable mobility system.",
      cards: [
        { t: "Framework agreements", d: "We define routes, frequencies and service levels together." },
        { t: "Scheduled flights", d: "We arrange dedicated business flights with certified operators." },
        { t: "Guaranteed seats", d: "Prepaid capacity reserved for your company." },
        { t: "Effortless use", d: "Your employees use pre-guaranteed seats, without booking every time." },
      ],
      tagline: "Not a charter every time. A corporate mobility infrastructure.",
    },
    how: {
      overline: "How it works",
      title: "A tailored program, end to end.",
      steps: [
        { t: "We analyze", d: "We study your mobility needs and recurring routes." },
        { t: "Framework agreement", d: "We build a tailored program for your company together." },
        { t: "Scheduled flights", d: "JetSeat arranges flights with certified operators on the agreed calendar." },
        { t: "Guaranteed seats", d: "Your employees find seats already reserved, ready to fly." },
      ],
      note: "Guaranteed capacity. Maximum flexibility. Zero uncertainty.",
    },
    outcomes: {
      overline: "What your company gets",
      title: "More value, less friction.",
      items: [
        { t: "Time recovered", d: "We drastically reduce travel times." },
        { t: "Uniform experience", d: "High standards guaranteed for every traveler." },
        { t: "Higher productivity", d: "More meetings, more decisions, more results." },
        { t: "A single partner", d: "We manage everything, end to end." },
        { t: "Stable scheduling", d: "Certain routes and times, every week." },
        { t: "Control & transparency", d: "Centralized reporting, analytics and billing." },
      ],
    },
    employee: {
      overline: "Benefits for your employees",
      title: "Less stress. More energy.",
      items: [
        "Arrive minutes before departure",
        "Fast, dedicated procedures",
        "Less stress, more energy for work",
        "More meetings in a single day",
        "Home in the evening",
      ],
    },
    why: {
      overline: "Why JetSeat",
      title: "Safety, efficiency, network.",
      pillars: [
        { t: "Safety first", d: "We work only with certified operators and rigorous procedures." },
        { t: "Business focus", d: "No superfluous luxury: only efficiency and concrete value for your business." },
        { t: "Network infrastructure", d: "The more companies join the network, the more routes, frequencies and value grow for everyone." },
      ],
    },
    lead: {
      overline: "Contact",
      title: "Let's talk about your program.",
      sub: "Tell us your needs: we'll get back to you to build your company's tailored mobility program.",
      companyName: "Company name", reference: "Company contact",
      mobile: "Mobile", phone: "Phone", email: "Email", reason: "Reason for contact",
      reasonPlaceholder: "Briefly describe the reason for your contact…",
      submit: "Send request", sending: "Sending…",
      success: "Request received. We'll be in touch shortly.",
      error: "Something went wrong. Please try again.",
      validation: "Please fill in the required fields",
    },
    corporate: {
      overline: "For companies",
      title: "Your tailored mobility program.",
      body: "We define routes, frequencies and service levels together. Capacity is prepaid and reserved for your company: your employees use pre-guaranteed seats, without booking every time.",
      benefits: [
        { t: "Guaranteed seats", d: "Prepaid, reserved capacity, always available for your team." },
        { t: "Stable scheduling", d: "Certain routes and times, set on your corporate calendar." },
        { t: "Dedicated management", d: "A single partner, centralized reporting and billing." },
      ],
      businessName: "Company name", sector: "Sector", seats: "Estimated seats in program",
      destinations: "Destinations of interest",
      destinationsPlaceholder: "e.g. Milan, Rome, London, French Riviera…",
      destinationsNote: "Routes aren't preset: we define them together at the agreement stage, based on your company's needs.",
      contactName: "Contact name", contactRole: "Contact role",
      email: "Business email", phone: "Phone",
      submit: "Request the program", sending: "Sending…",
      success: "Request received. We'll be in touch within 48 hours.",
      error: "Something went wrong. Please try again.",
    },
    partner: {
      overline: "Partnership",
      title: "AOC operators & advisors.",
      body: "JetSeat is asset-light: we build the network of AOC-certified operators and advisors that make mobility programs possible. If you run a fleet or represent recurring business clients, let's talk.",
      orgType: "Organization type", orgOpts: ["AOC operator", "Advisor", "Other"],
      company: "Company", name: "Contact", email: "Email", phone: "Phone", message: "Message",
      submit: "Get in touch", success: "Thank you. We'll be in touch.",
    },
    faq: {
      overline: "Frequently asked", title: "FAQ.",
      items: [
        { q: "How do you organize corporate flights for recurring business trips?", a: "With JetSeat you set up a tailored mobility program: we analyze your company's recurring routes, define routes, frequencies and service levels, and arrange dedicated business flights with certified operators. Employees find seats already reserved, without booking every time." },
        { q: "What are framework agreements for business mobility?", a: "A framework agreement is an arrangement where the company agrees in advance on routes, frequencies, service levels and seat capacity at a defined price. It ensures operational continuity, a predictable budget and priority on the most-used business routes." },
        { q: "Can you book private flights for companies in Italy?", a: "Yes. JetSeat operates dedicated private business flights for companies on the main Italian and European routes, through AOC-certified operators. Routes aren't preset: we define them together based on your company's needs." },
        { q: "How much does a corporate mobility program with a private jet cost?", a: "The cost depends on routes, frequencies and the number of seats in the program. Capacity is prepaid and reserved: we agree on a per-seat price together, with a predictable budget and centralized billing." },
        { q: "Are seats guaranteed and who operates the flights?", a: "Yes, seats are prepaid and guaranteed for your company. Flights are operated exclusively by certified operators with rigorous procedures: safety comes first." },
      ],
    },
    footer: { tagline: "Protecting people's time and turning it into value for companies.", missionLabel: "Our mission", rights: "All rights reserved.", admin: "Admin area" },
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState("it");
  const toggle = useCallback(() => setLang((l) => (l === "it" ? "en" : "it")), []);
  const t = dict[lang];
  return <I18nContext.Provider value={{ lang, setLang, toggle, t }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
